<template>
  <div class="content">
    <div class="left">
      <img
        src="http://growlib-glp-public.oss-cn-beijing.aliyuncs.com/res/1_624e937bdb6af/376392781.png"
        alt=""
      />
    </div>
    <div class="right">
      <div class="headline">- 作答区域 -</div>
      <div class="title">观看视频练习</div>
      <div class="desc">
        在每段视频都有一个“开始播放”按钮，当你准备好观看视频时，点击这个按钮，视频开始播放。
      </div>
      <div class="tip">请试一下：</div>
      <div class="showVideo">
        <video
          src="https://growlib-gw.oss-cn-beijing.aliyuncs.com/video/fuli/%E6%8E%A2%E7%A9%B6%E6%B5%AE%E5%8A%9B%E7%9A%84%E5%A4%A7%E5%B0%8F.mp4"
          controls
          ref="video"
        ></video>
        <img
          src="http://growlib-glp-public.oss-cn-beijing.aliyuncs.com/res/1_624ff999e0aeb/532032200.png"
          alt=""
          class="play"
          @click="play"
          v-if="showPlay"
        />
      </div>
      <div class="next" @click="go">下一题</div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      showPlay: true
    };
  },
  methods: {
    go() {
      this.$router.push({
        name: 'educationDarg'
      });
    },
    play() {
      this.video.play();
      this.showPlay = false;
    }
  },
  mounted() {
    this.video = this.$refs.video;
    this.video.addEventListener('pause', () => {
      this.showPlay = true
    });
  }
};
</script>

<style lang="less" scoped>
.content {
  width: 100%;
  height: 100%;
  display: flex;
  .left {
    width: 45%;
    background-image: url(http://growlib-glp-public.oss-cn-beijing.aliyuncs.com/res/1_624e9378b4f7a/606856192.png);
    background-size: 100% 100%;
    padding: 4% 2%;
    overflow-y: auto;
    img {
      width: 100%;
    }
  }
  .right {
    width: 55%;
    background-image: url(http://growlib-glp-public.oss-cn-beijing.aliyuncs.com/res/1_624e98747c556/505248194.png);
    background-size: 100% 100%;
    .headline {
      width: 100%;
      padding-top: 34px;
      text-align: center;
      font-size: 18px;
      font-weight: 500;
      color: #2144ff;
      line-height: 25px;
    }
    .title {
      margin-top: 44px;
      font-size: 16px;
      font-weight: 500;
      color: #000000;
      line-height: 22px;
      margin-left: 38px;
    }
    .desc {
      font-size: 16px;
      font-weight: 400;
      color: #383838;
      line-height: 26px;
      margin-left: 38px;
      margin-top: 6px;
    }
    .tip {
      padding-top: 22px;
      font-size: 16px;
      font-weight: 400;
      color: #666d73;
      margin-left: 38px;
      line-height: 22px;
    }
    .showVideo {
      padding: 0 27px;
      height: 360px;
      margin-top: 12px;
      position: relative;
      video {
        width: 100%;
        height: 100%;
      }
      .play {
        width: 50px;
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        margin: auto;
        cursor: pointer;
      }
    }
    .next {
      width: 269px;
      height: 44px;
      background: #f8f9ff;
      border-radius: 6px;
      border: 1px solid #4594fb;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 14px;
      font-weight: 400;
      color: #4594fb;
      line-height: 20px;
      margin: 0 auto;
      margin-top: 44px;
      cursor: pointer;
    }
  }
}
</style>
